// eslint-disable-next-line import/prefer-default-export
export const createPrefixer =
  (str = '') =>
  (val: TemplateStringsArray) =>
    `${str}${val}`;
